module.exports = __webpack_public_path__ + "img/bg-light.8b0cc666.png";